<template>
  <div class="header-component">
    <div class="header">
      <div class="navs">
        <span @click="gotoPage(index,0)" class="tran-all c-pointer"
          :class="index1==index?'active':''" v-for="(item,index) in navigation"
          :key="index">{{item.name}}</span>
      </div>
      <div class="right">
        <div>
          <span class="zsf-icon zsf-icon-touxiang mr-3"></span>
          <span>张三丰</span>
          <span class="ml-5">超级管理员</span>
        </div>
        <div @click="quit">
          <span class="zsf-icon zsf-icon-tuichu1"></span>
        </div>
      </div>
    </div>
    <div class="second">
      <div v-for="(item,index) in navigation[index1].child" :key="index" class="item tran-all"
        :class="index==index2?'active':''">
        <b class="c-pointer" @click="gotoPage(index1,index)">{{item.name}}</b>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import { navigation } from "../../config.js";
export default {
  data() {
    return {
      navigation: navigation,
      index1: 0,
      index2: 0
    };
  },

  computed: {
    getTabs() {
      return this.$store.getters.getTabs;
    },
    getTabActive() {
      return this.$store.getters.getTabActive;
    }
  },

  created() {},

  mounted() {
    console.log("mounted");
    console.log(document.body.clientWidth);
    console.log(this.getTabs);
  },

  methods: {
    gotoPage(index1, index2) {
      this.index1 = index1;
      this.index2 = index2;
      console.log(index1, index2);
      return;
      let tmp = [...this.navs];
      let url = tmp[index1]["childrens"][index2]["pageUrl"];
      let index = index1 + "-" + index2;
      let xTabs = this.$store.getters.getTabs;
      let xActive = this.$store.getters.getTabActive;
      this.$store.commit("setTabActive", index);
      let flag = true;
      for (let i = 0; i < xTabs.length; i++) {
        if (index === xTabs[i].index1 + "-" + xTabs[i].index2) {
          flag = false;
          break;
        }
      }
      if (flag) {
        for (let i = 0; i < xTabs.length; i++) {
          xTabs[i]["active"] = false;
        }
        xTabs.push({
          pageMenu: tmp[index1]["childrens"][index2]["pageMenu"],
          index1: index1,
          index2: index2,
          pageUrl: url,
          active: true
        });
        this.$store.commit("setTabs", xTabs);
        this.$router.push({ path: url });
      } else {
        for (let i = 0; i < xTabs.length; i++) {
          if (xTabs[i].index1 === index1 && xTabs[i].index2 === index2) {
            xTabs[i].active = true;
          } else {
            xTabs[i].active = false;
          }
        }
        if (index !== xActive) {
          this.$router.push({ path: url });
        }
      }
    },

    quit() {
      this.$confirm("确定要退出吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$store.commit("setTabActive", "0-0");
        this.$store.commit("setTabs", [
          {
            pageMenu: "首页",
            index1: 0,
            index2: 0,
            pageUrl: "/home",
            active: true
          }
        ]);
        this.$router.push({ path: "/login" });
      });
    }
  },

  components: {}
};
</script>

<style lang="less" rel="stylesheet/less" scoped="true">
@import "../../common/less/variable.less";

.header-component {
  .header {
    width: 100%;
    height: @headerHeight;
    background: @colorHeader;
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    padding: 0 10px;
    .navs {
      span {
        height: @headerHeight;
        line-height: @headerHeight;
        margin-right: 20px;
        font-weight: bold;
        &:hover,
        &.active {
          color: @colorBlue;
        }
      }
    }
    .right {
      display: flex;
      justify-content: center;
      align-items: stretch;
      div {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 10px;
      }
    }
  }
  .second {
    height: @headerSecondHeight;
    width: 100%;
    background: @colorHeaderSecond;
    .item {
      height: @headerSecondHeight;
      line-height: @headerSecondHeight;
      padding: 0 10px;
      /*color: #a1a1a1;*/
      float: left;
      position: relative;
      &.active,
      &:hover {
        background: @colorHeader;
        color: @colorBlue;
        b {
          color: @colorBlue;
        }
      }
    }
  }
}
</style>
